import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "checkbox",
    "groupCheckbox",
    "integration",
    "groupIntegration",
    "globalIntegration",
  ]

  toggleGroup(event) {
    const headerCheckbox = event.target
    const type = headerCheckbox.dataset.iocType
    const checked = headerCheckbox.checked

    this.checkboxTargets.forEach((cb) => {
      if (cb.dataset.iocType === type) {
        cb.checked = checked
      }
    })
  }

  toggleAll(event) {
    const checked = event.target.checked

    this.checkboxTargets.forEach((cb) => {
      cb.checked = checked
    })

    this.groupCheckboxTargets.forEach((cb) => {
      cb.checked = checked
    })
  }

  applyIntegrationToGroup(event) {
    const headerSelect = event.target
    const type = headerSelect.dataset.iocType
    const integrationId = headerSelect.value

    if (!integrationId) return

    this.integrationTargets.forEach((select) => {
      if (select.dataset.iocType === type) {
        select.value = integrationId
      }
    })
  }

  applyIntegrationToAll(event) {
    const integrationId = event.target.value

    if (!integrationId) return

    this.groupIntegrationTargets.forEach((select) => {
      select.value = integrationId
    })

    this.integrationTargets.forEach((select) => {
      select.value = integrationId
    })
  }
}
